module.exports = __webpack_public_path__ + "img/weixin.77cf99dc.svg";